import React from 'react'
import styled from 'styled-components'

const CallChatAttachmentMenu = ({ optionsList }) => {
    return (
        <Container>
            {optionsList?.map((item, index) => (
                <Item onClick={item.action} key={index}>
                    {item.icon}
                    <p>{item.text}</p>
                </Item>
            ))}
        </Container>
    )
}

export default CallChatAttachmentMenu

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  min-width: 140px;
  width: 140px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  
  :last-child {
    border: none;
  }
`

const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  width: 100%;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  border-bottom: 0.5px solid ${({ theme }) => theme.sidebar.borderColor};
  gap: 8px;
  cursor: pointer;
  transition: background 0.15s ease;
  
  svg {
    width: 18px;
    height: 18px;
    fill: ${({ theme }) => theme.chat.mediaBtnBorder};
    color: ${({ theme }) => theme.chat.mediaBtnColor};
    flex-shrink: 0;
  }
  
  p {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    margin: 0;
  }

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ theme }) => theme.menu.enterPhoneNumberBackground};
  }
`